/**
 * A NAME'S POSSESSIVE, AS A SENTENCE SAYS IT: "Wavemaker’s creators", "XERO’s team", and
 * for a name ending in s the apostrophe alone, "Influence Partners’ creators", "Hims & Hers’ team" — never
 * "Partners’s". The name is trimmed first. Pure, with no imports.
 *
 * The twin of dreamwell-api's application/managedTeam/possessive.ts and of brief-memory/words.ts `possessive` (the same
 * rule). It lives here, with nothing imported, because the review queue's turn words (features/review/turn.ts) load
 * with the sign-in page, whose budget brief-memory/words.ts and what it imports would break.
 */
export const possessive = (name: string): string => {
  const n = name.trim();
  return /s$/i.test(n) ? `${n}’` : `${n}’s`;
};
